import { login, type LoginOptions } from '@ideaflow/ui/login'
import type { DialogOptions } from '@ideaflow/ui/dialog'
import type { UserInfo } from '@/stores/user'

export async function loginWithBlankClose(
  options: LoginOptions = {},
  dialogOptions: DialogOptions = {},
): Promise<UserInfo | null> {
  let loginSettled = false

  const closePromise = new Promise<null>((resolve) => {
    const originalOnHide = dialogOptions.onHide

    dialogOptions.onHide = async (event?: Event) => {
      await originalOnHide?.(event)

      if (!loginSettled) {
        resolve(null)
      }
    }
  })

  const loginPromise = login(options, {
    ...dialogOptions,
    isBlankHide: true,
  })
    .then((userInfo) => {
      loginSettled = true
      return userInfo as UserInfo | null
    })
    .catch((error) => {
      loginSettled = true

      if (error === '用户取消登录') {
        return null
      }

      throw error
    })

  return Promise.race([loginPromise, closePromise])
}
